import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { dispatch } from '@store';
import { actions } from '@store/socket';
import { AuthService, FeaturesService } from '@services';
import { ConstantsUtil } from '@utils';
import { Feature } from '@enums';
import { initValidators } from '../../validators';

var InitServiceClass = /*#__PURE__*/function () {
  function InitServiceClass() {
    _classCallCheck(this, InitServiceClass);

    _defineProperty(this, "isInit", false);
  }

  _createClass(InitServiceClass, [{
    key: "setAppSocket",
    value: function () {
      var _setAppSocket = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(user) {
        var storeDispatch, socketUrl, token;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                storeDispatch = dispatch;
                socketUrl = process.env.socketUrl;
                token = AuthService.getTokenLocalStorage();
                return _context.abrupt("return", storeDispatch(actions.fetchSocketConnectRequest({
                  url: "".concat(socketUrl || '', "/exchange-rate?token=").concat(token || '')
                })));

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function setAppSocket(_x) {
        return _setAppSocket.apply(this, arguments);
      }

      return setAppSocket;
    }()
  }, {
    key: "init",
    value: function () {
      var _init = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var user;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (this.isInit) {
                  _context2.next = 17;
                  break;
                }

                InitServiceClass.showConsoleWarning();
                _context2.next = 4;
                return InitServiceClass.setServiceWorkers();

              case 4:
                _context2.next = 6;
                return InitServiceClass.setCustomYupValidators();

              case 6:
                InitServiceClass.setAuthToken();
                _context2.next = 9;
                return AuthService.getCurrentUser();

              case 9:
                user = _context2.sent;

                if (!FeaturesService.available(Feature.Socket)) {
                  _context2.next = 13;
                  break;
                }

                _context2.next = 13;
                return this.setAppSocket(user);

              case 13:
                this.isInit = true;
                return _context2.abrupt("return", user);

              case 17:
                throw new Error(ConstantsUtil.errors.APP_ALREADY_INIT_ERROR);

              case 18:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function init() {
        return _init.apply(this, arguments);
      }

      return init;
    }()
  }], [{
    key: "setServiceWorkers",
    value: function () {
      var _setServiceWorkers = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!('serviceWorker' in navigator && FeaturesService.available(Feature.ServiceWorker))) {
                  _context3.next = 4;
                  break;
                }

                _context3.next = 3;
                return navigator.serviceWorker.register('/service.worker.js');

              case 3:
                return _context3.abrupt("return", _context3.sent);

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function setServiceWorkers() {
        return _setServiceWorkers.apply(this, arguments);
      }

      return setServiceWorkers;
    }()
  }, {
    key: "setAuthToken",
    value: function setAuthToken() {
      var params = new Proxy(new URLSearchParams(window.location.search), {
        get: function get(searchParams, prop) {
          return searchParams.get(prop);
        }
      });
      var accessToken = params === null || params === void 0 ? void 0 : params.token;
      var refreshToken = params === null || params === void 0 ? void 0 : params.refreshtoken;

      if (accessToken && refreshToken) {
        AuthService.setTokenLocalStorage(accessToken, refreshToken);
        return accessToken;
      }

      return undefined;
    }
  }, {
    key: "setCustomYupValidators",
    value: function () {
      var _setCustomYupValidators = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                initValidators();
                return _context4.abrupt("return", Promise.resolve());

              case 2:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      function setCustomYupValidators() {
        return _setCustomYupValidators.apply(this, arguments);
      }

      return setCustomYupValidators;
    }()
  }, {
    key: "showConsoleWarning",
    value: function showConsoleWarning() {
      if (process.env.mode !== 'dev') {
        var stopStyles = ['color: red', 'font-weight: bold', 'font-size: 30px', '-webkit-text-stroke: 1px black'];
        var warningStyles = ['font-size: 20px']; // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        // eslint-disable-next-line no-console

        setTimeout(console.log.bind(console, '%cStop! 🛑', stopStyles.join(';')));
        setTimeout( // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        // eslint-disable-next-line no-console
        console.log.bind(console, '%cThis browser feature is intended for developers. If someone told you to copy and paste something here to enable a feature or "hack" someone\'s account, they are scammers. By following these steps, you will give them access to your account.', warningStyles.join(';')));
      }
    }
  }]);

  return InitServiceClass;
}();

var InitService = new InitServiceClass();
export { InitService };